<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('userCourseProgresses.title')" icon="briefcase">
            <app-default-button
                v-if="$can('create_user_course_progress')"
                :title="$addLabel('userCourseProgress')"
                @click="openUserCourseProgressModal()"
            />
        </app-page-top-section>

        <app-table
            id="user-course-progress-table"
            :options="options"
            @action="triggerActions"
        />

        <app-user-course-progress-modal
            v-if="isUserCourseProgressModalActive"
            v-model="isUserCourseProgressModalActive"
            :selected-url="selectedUrl"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('user-course-progress-table')"
            @cancelled="cancelled"
        />


    </div>
</template>

<script>
import UserCourseProgressMixin from "../../../Mixins/Learning/UserCourseProgressMixin";
import {axiosPost, urlGenerator} from "../../../../../common/Helper/AxiosHelper";
import {USERCOURSEPROGRESS} from "../../../../Config/ApiUrl";

export default {
    name: "UserCourseProgress",
    mixins: [UserCourseProgressMixin],
    data() {
        return {
            ucp: '',
            ucpId: '',
            userCourseProgresses: [],
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            isUserCourseProgressModalActive: false,
            confirmationModalActive: false,
        }
    },
    created() {
        this.$store.dispatch('getStatuses', 'user_course_progress')
    },
    watch: {
        isUserCourseProgressModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openUserCourseProgressModal() {
            this.selectedUrl = '';
            this.isUserCourseProgressModalActive = true;
        },
        triggerActions(row, action, active) {
            this.ucpId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'edit') {
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isUserCourseProgressModalActive = true;
            }
            // if (action.key === 'view_details') {
            //     window.location = urlGenerator(`${USERCOURSEPROGRESSWEB}/${row.id}`)
            //     // Add logic to handle view details action
            // }
            else {
                this.getAction(row, action, active)
            }
        },
        cancelled() {
            this.confirmationModalActive = false;
        },
    }
}
</script>
